import React from 'react';
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import DescribeYourProjectView from './DescribeYourProjectView';

import { CompileTOVS } from "@app/utils/CompileTOVS";
import { saveAs } from "file-saver";
import { Packer } from "docx";
import { DocumentCreator } from "@app/utils/DocumentCreator";

class ConnectedDescribeYourProjectContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            locale: this.props.locale ? this.props.locale : 'en',
            pageLoad: '',
            // Current Project
            bizObjective: '',
            validationErrors: {
                bizObjective: { show: false, check: null, errorMessage: ''  }
            },
            isLoading: false,
            errorMessage: '',
            successMessage: '',
            loadToSubmitTime: '',
            shareMessage: ''
        };// Current Project
        this.handleBizObjective = this.handleBizObjective.bind(this);
        this.generateDoc = this.generateDoc.bind(this);
    }

    componentDidMount() {
        if (this.state.pageLoad === '') {
            this.setState({
                pageLoad: new Date().valueOf()
            });
        }
        for (var i = 0; i < localStorage.length; i++){
            if (localStorage.key(i).startsWith('tovsForm.objective.')) {
                this.setState({
                    [localStorage.key(i).substring(19)]: localStorage.getItem(localStorage.key(i))
                });
            }
        }
    }

    // Current Project
    handleBizObjective(e) {
        let value = e.target.value;
        let validationErrors = this.state.validationErrors;
        if (value.length === 0) {
            validationErrors.bizObjective.show = true;
            validationErrors.bizObjective.errorMessage = 'You will need to write the business objective(s) that you want from this project.';
            validationErrors.bizObjective.check = false;
        } 
        else if (value.length < 32) {
            validationErrors.bizObjective.show = true;
            validationErrors.bizObjective.errorMessage = 'You don\'t need to write a lot but be sure the business objective(s) are clearly written.';
            validationErrors.bizObjective.check = false;
            localStorage.setItem('tovsForm.objective.bizObjective', value);
        }
        else {
            validationErrors.bizObjective.show = false;
            validationErrors.bizObjective.errorMessage = '';
            validationErrors.bizObjective.check = true;
            localStorage.setItem('tovsForm.objective.bizObjective', value);
        }
        this.setState({ 
            bizObjective: value,
            validationErrors: validationErrors
        });
    }

    generateDoc() {
        const data = new CompileTOVS().compile(); 
        var documentCreator = new DocumentCreator();
        var doc = documentCreator.create(data);

        Packer.toBlob(doc).then(function (blob) {
            saveAs(blob, "TradingOnlineVoucherScheme-" + Date.now() + ".docx");
        });
    }

    generateViewProps() {
        return {
            ...this.state,
            history: this.props.history,
            // Current Project
            handleBizObjective: this.handleBizObjective,
            generateDoc: this.generateDoc
        };
    }

    render() {
        const viewProps = this.generateViewProps();
        return (
            <DescribeYourProjectView {...viewProps} />
        );
    }
}

const mapStateToProps = state => {
    return {
        locale: state.i18n.locale
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setLocale: locale => dispatch(setLocale(locale))
    };
};

const DescribeYourProjectContainer = injectIntl(connect(mapStateToProps,mapDispatchToProps)(ConnectedDescribeYourProjectContainer));

export default DescribeYourProjectContainer;